/**
 * Minimal hash router. `#/` shows the menu; `#/<id>` opens a sketch (deep
 * link / kiosk auto-start). Emits the parsed route on change.
 */
export type Route = { kind: 'menu' } | { kind: 'sketch'; id: string };

export function parseRoute(hash: string): Route {
  const clean = hash.replace(/^#\/?/, '').trim();
  if (!clean) return { kind: 'menu' };
  return { kind: 'sketch', id: clean };
}

export class Router {
  private readonly onHash: () => void;

  constructor(private readonly onChange: (route: Route) => void) {
    this.onHash = () => this.onChange(parseRoute(location.hash));
    window.addEventListener('hashchange', this.onHash);
  }

  /** Fire the current route once at startup. */
  start(): void {
    this.onChange(parseRoute(location.hash));
  }

  go(route: Route): void {
    location.hash = route.kind === 'menu' ? '#/' : `#/${route.id}`;
  }

  dispose(): void {
    window.removeEventListener('hashchange', this.onHash);
  }
}
